module.exports = __webpack_public_path__ + "img/Roboto-Regular.8528a54.svg";